const hasChannelTalk = () => {
  return !!window.ChannelIO
}

export const showChannelTalk = () => {
  if (hasChannelTalk()) {
    window.ChannelIO('showMessenger');
  }
}
